export enum LINKER_MODEL_IDS {
  GOOGLE_DRIVE = 'trr-gdrive',
  SHAREPOINT = 'trr-sharepoint',
  CONFLUENCE = 'trr-confluence-dms',
}

export enum LINKER_LABELS {
  GOOGLE_DRIVE = 'Google Drive',
  SHAREPOINT = 'SharePoint',
  CONFLUENCE = 'Confluence',
}

export const LinkerModelIdToLabel = Object.freeze({
  [LINKER_MODEL_IDS.GOOGLE_DRIVE]: LINKER_LABELS.GOOGLE_DRIVE,
  [LINKER_MODEL_IDS.SHAREPOINT]: LINKER_LABELS.SHAREPOINT,
  [LINKER_MODEL_IDS.CONFLUENCE]: LINKER_LABELS.CONFLUENCE,
})

export type StateType = {
  loaded: boolean
  error: boolean
}

export type Source = 'Evidence' | 'Policy'

export interface ExtendedDocumentObject extends google.picker.DocumentObject {
  sizeBytes?: number
  caption?: string
}
